export default "__VITE_ASSET__BslNtEXy__"